import { useState } from "react";

import PurchaseReport from "./Reports/PurchaseReport";
import PurchaseReturnReport from "./Reports/PurchaseReturnReport";
import SalesReport from "./Reports/SalesReport";
import SalesReturnReport from "./Reports/SalesReturnReport";
import BalanceAmountReport from "./Reports/BalanceAmountReport";
import PaymentReport from "./Reports/PaymentReport";
import ProfitLossReport from "./Reports/ProfitLossReport";
import StaffPerformanceReport from "./Reports/StaffPerformanceReport";
import BatchProfitReport from "./Reports/BatchProfitReport";
import AccountingReport from "./Reports/AccountingReport";
import WriteOffsReport from "./Reports/WriteOffsReport";

function Reports() {
  return (
    <div className="p-6 space-y-0">
      <h1 className="text-2xl font-bold text-[#1A5EF9] mb-6">Reports</h1>
      <ReportTabs />
    </div>
  );
}

export default Reports;

const tabs = [
  { label: "Sales", key: "sales", Roles: ["ADMIN", "MANAGER", "USER"] },
  { label: "Purchase", key: "purchase", Roles: ["ADMIN", "MANAGER"] },
  { label: "Purchase Return", key: "purchaseReturn", Roles: ["ADMIN", "MANAGER"] },
  { label: "Sales Return", key: "salesReturn", Roles: ["ADMIN", "MANAGER", "USER"] },
  { label: "Payment Report", key: "paymentReport", Roles: ["ADMIN", "MANAGER", "USER"] },
  {
    label: "Balance Amount",
    key: "balanceAmountReport",
    Roles: ["ADMIN", "MANAGER", "USER"],
  },
  { label: "Profit & Loss", key: "profitLoss", Roles: ["ADMIN"] },
  { label: "Accounting", key: "accounting", Roles: ["ADMIN", "MANAGER"] },
  { label: "Staff Performance", key: "staffPerformance", Roles: ["ADMIN"] },
  { label: "Batch Profit", key: "batchProfit", Roles: ["ADMIN"] },
  { label: "Write Offs", key: "writeOffs", Roles: ["ADMIN"] },
];

function ReportTabs() {
  const [activeTab, setActiveTab] = useState("sales");

  return (
    <div className="w-full">
      <div className="inline-flex bg-[#F0F4FF] rounded-[12px] p-1 gap-1 flex-wrap mb-6">
        {tabs.map(
          (tab) =>
            tab.Roles.map((r) => r.toUpperCase()).includes((localStorage.getItem("role") ?? "").toUpperCase()) && (
              <button
                key={tab.key}
                className={`h-9 px-5 rounded-[10px] text-sm font-medium transition-all cursor-pointer ${
                  activeTab === tab.key
                    ? "bg-[#1A5EF9] text-white shadow-[0_2px_8px_rgba(26,94,249,0.25)]"
                    : "text-[#52627C] hover:bg-white/60"
                }`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ),
        )}
      </div>
      <div>
        {activeTab === "sales" && <SalesReport />}
        {activeTab === "purchase" && <PurchaseReport />}
        {activeTab === "purchaseReturn" && <PurchaseReturnReport />}
        {activeTab === "salesReturn" && <SalesReturnReport />}
        {activeTab === "paymentReport" && <PaymentReport />}
        {activeTab === "balanceAmountReport" && <BalanceAmountReport />}
        {activeTab === "profitLoss" && <ProfitLossReport />}
        {activeTab === "accounting" && <AccountingReport />}
        {activeTab === "staffPerformance" && <StaffPerformanceReport />}
        {activeTab === "batchProfit" && <BatchProfitReport />}
        {activeTab === "writeOffs" && <WriteOffsReport />}
      </div>
    </div>
  );
}
